<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-popup classContent="popup-example" title="Upload file" :active.sync="popupUploadFile">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          File type
          <v-select :closeOnSelect="true" v-model="params.fileType" :options="fileTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="showTransactions"/>
        </div>
      </div>
      <div class="vx-row mb-6" v-if="transactionsList.length>0">
        <div class="vx-col w-full">
          Transactions
          <v-select multiple :closeOnSelect="true" label="name" v-model="params.transactions" :options="transactionsList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="accountNumbers.length>0">
        <div class="vx-col w-full">
          Account numbers
          <v-select :closeOnSelect="true" v-model="params.accountNumbers" :options="accountNumbers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="userWallets.length>0">
        <div class="vx-col w-full">
          User Wallets
          <v-select :closeOnSelect="true" v-model="params.userWallets" :options="userWallets" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-12">
        <div class="vx-col w-full">
          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-complete="successUpload" v-on:vdropzone-error="uploadError" v-on:vdropzone-canceled="uploadError"></vue-dropzone>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="uploadFile()" color="primary" type="filled">Upload</vs-button>
        </div>
      </div>
    </vs-popup>
       
  <vs-popup classContent="popup-example" title="Change Country" :active.sync="popupChangeCountry">
       
       
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           Country
           <v-select required v-model="params.country" label="cl_Country" :options="country" :dir="$vs.rtl ? 'rtl' : 'ltr'"  />
         </div>
       </div>
       
 
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           <vs-button @click="sendData('change-country')" color="primary" type="filled">Change</vs-button>
         </div>
       </div>
  </vs-popup>
    <vs-popup classContent="popup-example" title="Change user broker" :active.sync="popupChangeBroker">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Affiliates
          <v-select :closeOnSelect="true" v-model="params.broker_name" label="bk_name" :options="brokers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('change-broker')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    
    <vs-popup classContent="popup-example" title="Send message" :active.sync="popupSendMessage">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Message
          <vs-textarea rows="5" label="Add description" v-model="message" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('sendMessage')" color="primary" type="filled">Send</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Block user" :active.sync="popupBlockUser">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Comment
          <vs-input class="inputx w-full" label="dep_wallet1" v-model="params.comment"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('block-user')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Add bank" :active.sync="popupAddBank">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Username" :value="$route.params.email" disabled/>
        </div>
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Bank name" v-model="params.bankname1" />
        </div>
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Bank address" v-model="params.bankadress1" />
        </div>
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="IBAN" v-model="params.iban" />
        </div>
        <div class="vx-col w-full">          
          <vs-input class="inputx w-full" label="SWIFT" v-model="params.swift" />
        </div>
        <div class="vx-col w-full">
          Account number
          <vs-input class="inputx w-full" label="Account number" v-model="params.account_num1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('add-bank')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Reset user password" :active.sync="popupResetPassword">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input label="New password" class="inputx w-full" v-model="params.password" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('reset-password')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Insert Manual Order" :active.sync="popupInserSell">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Transaction date
          <datepicker format="yyyy-MM-dd 00:00:00" placeholder="Select Date" v-model="params.tran_date1"></datepicker>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="dep_wallet1" v-model="params.dep_wallet1"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="cl_account_number1" v-model="params.cl_account_number1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Accounts
          <v-select :closeOnSelect="true" v-model="params.dep_account1" label="acc_name" :options="bizAccounts" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="btc_accepted1" v-model="params.btc_accepted1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="eur_sent1" v-model="params.eur_sent1" />
        </div>
      </div> 
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="eur_worth1" v-model="params.eur_worth1" />
        </div>
      </div>     
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('insert-sell')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update verification status" :active.sync="popupVerificationStatus">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Status</label>
          <select v-model="params.status"  class="inputx w-full" label="Status">
            <option>declined</option>
            <option>approved</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Reason</label>
          <select v-model="params.reason" class="form-control inputx w-full">
              <option></option>
              <option>bad pic</option>
              <option>brand</option>
              <option>outdated</option>
              <option>mismatching details</option>
              <option>client request</option>
              <option>wrong doc</option>
              <option>compliance</option>
              <option>suspected fraud</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Email</label>
          <select v-model="params.checkbox"  class="inputx w-full" label="Email">
            <option>yes</option>
            <option>no</option>
          </select>
        </div>
      </div> 
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-verification-status')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <div class="vx-row mb-4">
        <div class="vx-col w-1/4">
          <vs-button label="button" @click="popupResetPassword=true" class="ml-auto w-full">Reset Password</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="sendData('resend-verification-email')" class="ml-auto w-full">Resend verification email</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="sendData('verify-email')" class="ml-auto w-full">Verify email account</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="sendData('resend-user-mail')" class="ml-auto w-full">Send user reset password email</vs-button>
        </div>
        <vs-divider /> 
        
      
        <div class="vx-col w-1/4">
          <vs-button @click="popupChangeCountry=true" class="ml-auto w-full">Change Country</vs-button>
        </div>  
        <div class="vx-col w-1/4">
          <vs-button @click="popupVerificationStatus=true" class="ml-auto w-full">Update user verification status</vs-button>
        </div>        
        <div class="vx-col w-1/4">
          <vs-button @click="getAccounts" class="ml-auto w-full">Insert Manual Order</vs-button>
        </div>
        <div class="vx-col w-1/4" >
          <vs-button @click="popupChangeBroker=true" class="ml-auto w-full">Change user affiliate</vs-button>
        </div>
       
        <vs-divider />
        <div class="vx-col w-1/4">
          <vs-button @click="popupUploadFile=true" class="ml-auto w-full">Upload file for user</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="popupBlockUser=true" class="ml-auto w-full">Block user</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="popupChangeCountry=true" class="ml-auto w-full">Add bank</vs-button>
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="popupSendMessage=true" class="ml-auto w-full">Send message</vs-button>
        </div>
      </div>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import country from '../../../resources/country.json';
export default {
  data() {
    return {
      message:null,
      popupInserSell: false,
      popupChangeBroker: false,
      popupResetPassword: false,
      popupChangeCountry: false,
      popupUploadFile: false,
      popupBlockUser: false,
      popupAddBank: false,
      popupSendMessage: false,
      popupVerificationStatus:false,
      bizAccounts: this.$store.state.accounts, 
      brokers: this.$store.state.brokers,
      fileTypes:this.$store.state.docNames,
      country: country,
      params: {
        tran_date1:  new Date(),
      },
      fileParams:{},
      accountNumbers:[],
      userWallets:[],
      transactionsList:[],
      dropzoneOptions: {
          url: '/api/client',
          thumbnailWidth: 150,
          maxFilesize: 100,
          paramName: 'document',
          withCredentials: true,
          //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          autoProcessQueue: false
      },
      successStatuses:['cl doc path inserted','password reset success!','waiting for user to reset!','waiting for user to verify!','updated new client details!','Doc Status Updated!','method approved!','payment method status updated!','bk checkpoint updated!','verification status updated!','just retroed that tran!','inserted note!']
    }
  },
  components:{
    'v-select': vSelect,
    Datepicker,
    'vue-dropzone': vue2Dropzone
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    uploadError: function(){
      this.$vs.loading.close();
    },
    getAccounts: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-accounts');
      params.append('email', this.$route.params.email);
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.popupInserSell=true;
        that.$vs.loading.close();
        let an = JSON.parse(data.data.Accounts[0].object);
        that.params.cl_account_number1 = an.account_number;
        let ad = JSON.parse(data.data.Address[0].object);
        that.$set(that.params,'dep_wallet1',ad.address);
      })
    },
    showTransactions: function(){
      let that = this;
      const params = new URLSearchParams();
      this.transactionsList.splice(0);
      this.accountNumbers.splice(0);
      this.userWallets.splice(0);
      if(this.params.fileType==='bank statement'){
        params.append('email', this.$route.params.email);
        params.append('type', 'get-banks');
        this.$vs.loading();
        axios.post("/api/client",params)
        .then((response) => {
          for(let i in response.data.data){
            that.accountNumbers.push(response.data.data[i].account_number);
          }
          that.$vs.loading.close();
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed','Error'); })
      } else if(this.params.fileType==='wallet proof'){
        params.append('email', this.$route.params.email);
        params.append('type', 'get-wallets');
        this.$vs.loading();
        axios.post("/api/client",params)
        .then((response) => {          
          for(let i in response.data){
            let data = JSON.parse(response.data[i].object);
            that.userWallets.push(data.address);
          }
          that.$vs.loading.close();
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed','Error'); })
      } else if(this.params.fileType==='crypto screenshot transfer' || this.params.fileType==='DOD' || this.params.fileType==='email correspondence' || this.params.fileType==='wire proof'){
        params.append('uname', this.$route.params.email);
        this.$vs.loading();
        axios.post("/api/transactions",params)
        .then((response) => {
          for(let i in response.data){
            let name = response.data[i].id + ' - '+ response.data[i].dep_date + ' - '+ response.data[i].amount;
            that.transactionsList.push({id:response.data[i].id,name:name});
          }
          that.$vs.loading.close();
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed','Error'); })
      }
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    uploadFile: function(){
      this.$vs.loading();
      this.$refs.myVueDropzone.processQueue();
    },
    sendingEvent (file, xhr, formData) {
        formData.append('type', 'file-upload');
        formData.append('email', this.$route.params.email);
        formData.append('get_doc_names-search',this.params.fileType);
        if(this.params.fileType==='crypto screenshot transfer' || this.params.fileType==='DOD' || this.params.fileType==='email correspondence' || this.params.fileType==='wire proof'){
          let str = '';
          for(let i in this.params.transactions){
            str += ','+this.params.transactions[i].id;
          }
          let transactions = str.substr(1);
          formData.append('transactions_unique',transactions);
        }
        if(this.params.fileType==='bank statement'){
          formData.append('accountNumbers',this.params.accountNumbers);
        }
        else if(this.params.fileType==='wallet proof'){
          formData.append('userWallets',this.params.userWallets);
        }
    },
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('email', this.$route.params.email);
      switch(type){
        case 'resend-verification-email':{
          break;
        }
        case 'verify-email':{
          break;
        }
        case 'update-verification-status':{
          params.append('comment', this.params.comment);
          params.append('reason', this.params.reason);
          params.append('status', this.params.status);
          params.append('checkbox', this.params.checkbox);
          break;
        }
        case 'block-user':{
          params.append('comment', this.params.comment);
          break;
        }
        case 'insert-sell':{
          params.append('tran_date1', this.params.tran_date1);
          params.append('cl_name1', this.$route.params.email);
          params.append('dep_wallet1', this.params.dep_wallet1);
          params.append('cl_account_number1', this.params.cl_account_number1);
          params.append('dep_account1', this.params.dep_account1.acc_name);
          params.append('btc_accepted1', this.params.btc_accepted1);
          params.append('eur_sent1', this.params.eur_sent1);
          params.append('eur_worth1', this.params.eur_worth1);
          break;
        }
        case 'change-broker':
          params.append('broker_name', this.params.broker_name.bk_name);
          break;
        case 'change-country':
          console.log(this.params.country.cl_Country)
          params.append('cl_country', this.params.country.cl_Country);
          break;
        case 'bank-deposit':
          params.append('created_at1', this.params.created_at1);
          break;
        case 'reset-password':
          params.append('password', this.params.password);
          break;
        case 'sendMessage':
          params.append('message', this.message);
          break;
        case 'add-bank':
          params.append('bank_name1', this.params.bankname1);
          params.append('bank_adress1', this.params.bankadress1);
          params.append('IBAN', this.params.iban);
          params.append('SWIFT', this.params.swift);
          params.append('account_num1', this.params.account_num1);
          break;
      }
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'|| that.successStatuses.indexOf(data.data[0].out1)!==-1){
          that.openAlert('success','Success',data.data[0].out1);
          that.reset();
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
      })
      .catch((data) => { that.$vs.loading.close(); that.openAlert('danger','Failed',data[0].out1); })
    },
    reset: function(){
      this.message=null;
      this.transactionsList.splice(0);
      this.$refs.myVueDropzone.removeAllFiles();
      this.popupInserSell= false;
      this.popupChangeBroker= false;
      this.popupResetPassword= false;
      this.popupUploadFile= false;
      this.popupAddBank = false;
      this.popupSendMessage = false;
      this.popupChangeCountry = false;
      this.popupBlockUser= false;
      this.popupVerificationStatus=false;
      let wallet = this.params.dep_wallet1;
      if(this.params.status==='declined'){
        this.params = {dep_wallet1:wallet,comment:this.params.comment,reason:this.params.reason};
      } else
        this.params = {dep_wallet1:wallet};
      this.params.tran_date1 = new Date();
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-transactions');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData = response.data;
      })
      .catch(() => { })
    },
    successUpload(response) {
        let res = JSON.parse(response.xhr.response);
        this.$vs.loading.close();
        if(res[0].out1==='done!' || this.successStatuses.indexOf(res[0].out1)!==-1){
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'File uploaded' })
          this.reset();
        } else
          this.$vs.notify({ color: 'danger', title: 'Failed', text: res[0].out1 })
    },
    showError(){
      
    }
  }
}
</script>